import * as React from 'react';
import { IconProps } from '../types';

const IcAverage = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={props?.fill ?? '#232F3E'}
      d="M4.736 1.8h15.452c.503.057.994.422 1.07.945.09.797.012 1.6.042 2.4-.014.533.077 1.181-.374 1.572-.553.596-1.667.319-1.887-.462-.145-.697-.045-1.416-.077-2.123-3.804 0-7.607-.002-11.411.001 2.183 2.357 4.375 4.708 6.563 7.06.639.53.547 1.52-.088 2.009-2.14 2.218-4.276 4.44-6.41 6.665 3.782.005 7.564.001 11.348.001.024-.68-.153-1.568.51-2.01.668-.505 1.758-.014 1.797.83.048.798.039 1.601.008 2.401-.004.58-.51 1.036-1.061 1.111H4.76c-.49-.08-.94-.44-1.028-.945-.1-.443.125-.872.435-1.171 2.547-2.648 5.096-5.293 7.64-7.945-2.52-2.713-5.04-5.427-7.566-8.135-.28-.296-.57-.655-.526-1.092.014-.565.481-1.015 1.021-1.112Z"
    />
  </svg>
);

export default IcAverage;
